import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OffcanvasService {
  public renderer: Renderer2;
  public documentClickListener: any;
  public openOffcanvasMap: Map<HTMLElement, HTMLElement[]> = new Map();

  constructor(
    private router: Router,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);

    // Subscribe to route changes
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.hideAllOffcanvas();
      }
    });
  }

  debounce(func: Function, delay: number) {
    clearTimeout(func['timeoutId']);
    func['timeoutId'] = setTimeout(() => func(), delay);
  }

  toggleVisibility(element: HTMLElement, buttonElements: HTMLElement[]) {
    if (element.classList.contains('show')) {
      this.hideOffcanvas(element);
    } else {
      if (this.openOffcanvasMap.size > 0) {
        this.hideAllOffcanvas();
      }
      this.showOffcanvas(element, buttonElements);
    }
  }

  showOffcanvas(element: HTMLElement, buttonElements: HTMLElement[]) {
    this.renderer.addClass(element, 'show');
    this.renderer.removeClass(element, 'hiding');
    this.openOffcanvasMap.set(element, buttonElements);
    this.addDocumentClickListener();
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('overflow-hidden');
  }

  hideOffcanvas(element: HTMLElement) {
    this.renderer.addClass(element, 'hiding');
    element.addEventListener('transitionend', () => {
      if (element.classList.contains('hiding')) {
        this.renderer.removeClass(element, 'show');
        this.renderer.removeClass(element, 'hiding');
      }
      this.openOffcanvasMap.delete(element);
      if (this.openOffcanvasMap.size === 0) {
        this.removeDocumentClickListener();
      }
    }, { once: true });
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('overflow-hidden');
  }

  hideAllOffcanvas() {
    this.openOffcanvasMap.forEach((buttons, offcanvas) => {
      this.hideOffcanvas(offcanvas);
    });
  }

  addDocumentClickListener() {
    if (!this.documentClickListener) {
      this.documentClickListener = this.renderer.listen('document', 'click', (event) => {
        let isOutside = true;
        this.openOffcanvasMap.forEach((buttons, offcanvas) => {
          if (offcanvas.contains(event.target) || buttons.some(button => button.contains(event.target))) {
            isOutside = false;
          }
        });
        if (isOutside) {
          this.hideAllOffcanvas();
        }
      });
    }
  }

  removeDocumentClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }
}
